
export function stopEvent(e: Event) {
    e.stopPropagation?.();
    e.preventDefault?.();
}
export function stopProp(e: Event) {
    e.stopPropagation?.();
}

export function pressEnter(event: any, callback = () => {}) {
    if (event.key === "Enter") {
        stopEvent(event);
        callback();
    }
}

